import { useScreenSize } from "~/hooks/use-screen-size";

import { TourOverlay } from "./tour-overlay";
import { TourTooltip } from "./tour-tooltip";
import { WelcomeModal } from "./welcome-modal";

// AIDEV-NOTE: Tour UI is split so multiple TourRoots on one page don't
// double-render the overlay/tooltip. TourRoot owns only a page's welcome modal;
// the overlay + tooltip render exactly once via <TourViewport/> (mounted in
// root.tsx). Desktop-only: tours are disabled on mobile.

interface TourRootProps {
    /** ID of the tour to show welcome modal for */
    tourId?: string;
}

export function TourRoot({ tourId }: TourRootProps) {
    const screenSize = useScreenSize();

    // AIDEV-NOTE: Don't render tour UI on mobile (< md breakpoint)
    // Checked client-side to avoid SSR hydration issues
    if (screenSize.lessThan("md") || !tourId) {
        return null;
    }

    return <WelcomeModal tourId={tourId} />;
}

// AIDEV-NOTE: The single global tour overlay + tooltip. Mount ONCE (root.tsx)
// so page-level TourRoots and the onboarding container don't stack duplicates.
export function TourViewport() {
    const screenSize = useScreenSize();

    if (screenSize.lessThan("md")) {
        return null;
    }

    return (
        <>
            <TourOverlay allowBackdropClose={false} />
            <TourTooltip />
        </>
    );
}
